import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";
import {
  values_grey,
  values_grey_Tab,
  values_white_Tab,
  values_white,
  values_grey_mobile,
  values_white_mobile,
} from "../../../../public/assets";

export const ValuesContainer = styled.div`
  width: 400px;
  height: 382px;
  flex-shrink: 0;
  background-image: url("/assets/svg/values_white.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    width: 300px;
    height: 358px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    /* flex-wrap: wrap; */
  }
  @media screen and (max-width: 768px) {
    width: 592px;
    height: 358px;
    background-image: url(${"/assets/svg/values_white_tab.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
`;
export const ValuesContainer1 = styled.div`
  width: 400px;
  height: 410px;
  flex-shrink: 0;
  background-image: url("/assets/svg/values_white.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    width: 300px;
    height: 360px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    /* flex-wrap: wrap; */
  }
  @media screen and (max-width: 768px) {
    width: 592px;
    height: 320px;
    background-image: url(${"/assets/svg/values_white_tab.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    height: 340px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    height: 340px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    height: 340px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
`;

export const DesignContainer = styled.div`
  width: 400px;
  height: 382px;
  flex-shrink: 0;
  background-image: url("/assets/svg/values_grey.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    width: 300px;
    height: 358px;
    background-image: url(${"/assets/svg/values_grey_phone.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /* flex-wrap: wrap; */
  }
  @media screen and (max-width: 768px) {
    width: 592px;
    height: 358px;
    background-image: url("/assets/svg/values_grey_tab.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    height: 330px;
    background-image: url(${"/assets/svg/values_grey_phone.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    height: 330px;
    background-image: url(${"/assets/svg/values_grey_phone.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    height: 330px;
    background-image: url(${"/assets/svg/values_grey_phone.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
`;
export const DesignContainer1 = styled.div`
  width: 400px;
  height: 382px;
  flex-shrink: 0;
  background-image: url("/assets/svg/values_white.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    width: 300px;
    height: 358px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /* flex-wrap: wrap; */
  }
  @media screen and (max-width: 768px) {
    width: 592px;
    height: 358px;
    background-image: url(${"/assets/svg/values_white_tab.png"});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    height: 330px;
    background-image: url("/assets/svg/Values_white_phone.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
`;

export const Rocket = styled.img`
  width: 108px;
  height: 108px;
  flex-shrink: 0;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 375px) {
    width: 80px;
    height: 80px;
  }
`;

export const User = styled.img`
  width: 108px;
  height: 108px;
  flex-shrink: 0;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 375px) {
    width: 80px;
    height: 80px;
  }
`;

export const TitleText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.heading3.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;
export const TitleText1 = styled.div`
  text-align: center;
  /* font-size: ${fipayFonts.fipayFonts.heading3.size}; */
  font-size: 29px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;
export const TitleText2 = styled.div`
  text-align: center;
  /* font-size: ${fipayFonts.fipayFonts.heading3.size}; */
  font-size: 31.5px;
  /* font-weight: ${fipayFonts.fipayFonts.fontWeight.bold}; */
  font-weight: 550;
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.temp};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;

export const SubtitleText = styled.div`
  width: 290px;
  height: 96px;
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 1024px) {
    width: 290px;
    height: 96px;
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    width: 484px;
    height: 72px;
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    width: 290px;
    height: 96px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    width: 290px;
    height: 96px;
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: center;
  }
`;
